<template>
  <el-form :model="query" label-width="90px" v-loading="loading">
    <el-row>
      <el-col :span="8">
        <el-form-item label="条件">
          <el-input
            v-model="query.keyword"
            maxlength="30"
            placeholder="名称、流程号"
            clearable
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="年度">
          <el-select
            v-model="query.workYear"
            filterable
            clearable
            style="width: 100%"
          >
            <el-option v-for="item in data.workYears" :key="item" :value="item">
              {{ item }}
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <slot name="footer"></slot>
    </el-row>
    <el-form-item>
      <el-button type="primary" icon="el-icon-search" @click="onSearch">
        搜索
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      query: {},
      loading: false
    };
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    onSearch() {
      this.$emit('search', this.query);
    }
  }
};
</script>